import React, { use, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getTagInfoforSupplier, getUserProfile } from "../services/api";
import { submitOrder } from "../services/orderService";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { usePTagForm } from "../contexts/PTagFormContext";
import i18n from "i18next";
import {
    Box,
    Button,
    Container,
    Stack,
    TextField,
    Typography,
    Alert,
    CircularProgress,
    useMediaQuery,
    IconButton,
    Divider,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
} from "@mui/material";
import {
    Trash2,
    Edit,
    Eye,
    DiamondPlus,
    DiamondMinus,
    ShoppingCart as ShoppingCartIcon,
} from "lucide-react";
import { useTranslation } from 'react-i18next';
import { validatePhoneNumber, validateEmail, validateLastName } from "../utils/validation";
import PickUpMap from "../pages/PickUpMap";


const ShoppingCart = () => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    const [loadingButton, setloadingButton] = useState(false);
    const { forms, activeFormIndex, setActiveFormIndex, removeForm, removeAllForms, form, setForm, formsAdded, decrementFormsAdded, setOrderConfirmedTrue, removeAllFormsAdded } = usePTagForm();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:768px)");
    const [showPickupMaps, setShowPickupMaps] = useState(false);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [orderConfirmed, setOrderConfirmed] = useState(false);
    const language = i18n.language;

    const handleClosePopup = () => {
        setShowPickupMaps(false);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        for (let i = 0; i < forms.length; i++) {
            if (forms[i].option === "") {
                removeForm(i);
            }
        }
    }, []);

    const handleChange = (field) => (e) => {
        setActiveFormIndex(0);
        const value = e.target.value;
        setForm((prev) => ({ ...prev, [field]: value }));

        // Real-time validation for specific fields
        if (field === "phoneNumber") {
            const phoneError = validatePhoneNumber(value, t);
            setFieldErrors((prev) => ({
                ...prev,
                phoneNumber: phoneError,
            }));
        } else if (field === "email") {
            const emailError = validateEmail(value, t);
            setFieldErrors((prev) => ({
                ...prev,
                email: emailError,
            }));
        } else if (field === "lastName") {
            const lastNameError = validateLastName(value, t);
            setFieldErrors((prev) => ({
                ...prev,
                lastName: lastNameError,
            }));
        } else if (field === "delivery") {
            setForm(prev => ({
                ...prev,
                delivery: value,
                ...(value === "SF-HOME-DELIVERY"
                    ? { netCode: "", serviceName: "", shippingAddress: "", attrName: "" }
                    : { address: "", }),
            }));
        } else {
            // Clear error when field is filled
            setFieldErrors((prev) => ({
                ...prev,
                [field]: "",
            }));
        }
        for (let i = 0; i < forms.length; i++) {
            forms[i].attrName = forms[0].attrName;
            forms[i].delivery = forms[0].delivery;
            forms[i].email = forms[0].email;
            forms[i].lastName = forms[0].lastName;
            forms[i].netCode = forms[0].netCode;
            forms[i].payment = forms[0].payment;
            forms[i].paymentWay = forms[0].paymentWay;
            forms[i].address = forms[0].address;
            forms[i].phoneNumber = forms[0].phoneNumber;
            forms[i].shippingAddress = forms[0].shippingAddress;
            forms[i].serviceName = forms[0].serviceName;
        }
    };

    const handleConfirm = async () => {
        setloadingButton(true);
        try {
            const result = await submitOrder(forms, language);
        } catch (err) {
            console.error("Order submission failed:", err);
        } finally {
            setOrderConfirmedTrue();
            if (formsAdded > 0) {
                decrementFormsAdded();
            }
            setloadingButton(false);
            removeAllFormsAdded();
            navigate("/ptag-air/confirmation");
        }
    };

    const isFormValid =
        form.lastName &&
        form.phoneNumber &&
        form.email &&
        form.delivery &&
        form.paymentWay &&
        form.address || form.shippingAddress &&
        !fieldErrors.phoneNumber &&
        !fieldErrors.email &&
        !fieldErrors.lastName;

    const popupOverlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // Ensure popup is above other content
        overflow: "auto",
        padding: "0 10px", // Add horizontal padding for mobile
    };

    const popupContentStyle2 = {
        backgroundColor: "#FFFFFF",
        padding: "30px",
        borderRadius: "30px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        width: isMobile ? "93%" : "1200px",
        display: "flex",
        flexDirection: "column",
        gap: 20,
    };

    const closeButtonStyle = {
        position: "absolute", top: 0, right: isMobile ? "-10px" : 0,
        cursor: "pointer",
    };

    if (loading) {
        return (
            <Box
                sx={{
                    bgcolor: "#fcf8f3",
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        {/* 載入中... */}
                        <img src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif" alt=""
                            style={{
                                width: '150px',
                                height: 'auto',
                                mixBlendMode: 'multiply',
                            }} />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ bgcolor: "#fcf8f3", minHeight: "100vh" }}>
            {/* Header */}
            <Navbar />

            {/* Main Content */}
            <Container
                sx={{
                    py: { xs: 4, md: 8 },
                    px: { xs: 2 },
                    mt: "70px", // Add top margin to account for fixed navbar height
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        mb: forms.length === 0 ? 0 : 3,
                        fontWeight: "bold",
                        fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    }}
                >
                    {t('Shopping Cart')}
                </Typography>

                {/* Empty Cart State */}
                {forms.length === 0 ? (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "60vh",
                            py: 4,
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: 120, md: 150 },
                                height: { xs: 120, md: 150 },
                                borderRadius: "50%",
                                backgroundColor: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 3,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            }}
                        >
                            <ShoppingCartIcon size={isMobile ? 60 : 80} strokeWidth={1.5} color="#d1d1d1" />
                        </Box>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: "bold",
                                mb: 1,
                                fontSize: { xs: "20px", md: "24px" },
                            }}
                        >
                            {t('Your cart is empty')}
                        </Typography>
                        <Typography
                            sx={{
                                color: "#666",
                                mb: 4,
                                textAlign: "center",
                                fontSize: { xs: "14px", md: "16px" },
                            }}
                        >
                            {t("Start adding items to your cart by choosing a product below")}
                        </Typography>

                        {/* Product Selection Cards */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", md: "row" },
                                gap: 3,
                                width: "100%",
                                maxWidth: "800px",
                            }}
                        >
                            {/* PTag Card */}
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: "#fff",
                                    borderRadius: "16px",
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        mb: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src="/icons/ptag-2.png"
                                        alt="PTag"
                                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                    />
                                </Box>
                                <Typography variant="h6" fontWeight="bold" mb={1}>
                                    PTag
                                </Typography>
                                <Typography
                                    sx={{
                                        color: "#666",
                                        textAlign: "center",
                                        mb: 3,
                                        fontSize: "14px",
                                    }}
                                >
                                    {t("Classic pet tag with QR code")}
                                </Typography>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => navigate("/ptag/payment")}
                                    sx={{
                                        backgroundColor: "#FFB60C",
                                        color: "black",
                                        fontWeight: "bold",
                                        py: 1.5,
                                        textTransform: "none",
                                        "&:hover": {
                                            backgroundColor: "#e5a300",
                                        },
                                    }}
                                >
                                    {t("Choose PTag")}
                                </Button>
                            </Box>

                            {/* PTag Air Card */}
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: "#fff",
                                    borderRadius: "16px",
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        mb: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src="/icons/ptagair-2.png"
                                        alt="PTag Air"
                                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                    />
                                </Box>
                                <Typography variant="h6" fontWeight="bold" mb={1}>
                                    PTag Air
                                </Typography>
                                <Typography
                                    sx={{
                                        color: "#666",
                                        textAlign: "center",
                                        mb: 3,
                                        fontSize: "14px",
                                    }}
                                >
                                    {t("Smart AirTag holder for pets")}
                                </Typography>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => navigate("/ptag-air/payment")}
                                    sx={{
                                        backgroundColor: "#65A8FB",
                                        color: "white",
                                        fontWeight: "bold",
                                        py: 1.5,
                                        textTransform: "none",
                                        "&:hover": {
                                            backgroundColor: "#5090e0",
                                        },
                                    }}
                                >
                                    {t("Choose PTag Air")}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <>
                        {/* Cart Items */}
                        <div style={{ display: "flex", flexDirection: 'column', gap: "10px", marginBottom: "20px" }}>
                            {forms.map((_, index) => (
                                <div key={index} style={{ display: "flex", alignItems: "center" }}>
                                    <div
                                        onMouseEnter={() => setActiveFormIndex(index)}
                                        style={{
                                            padding: "16px",
                                            background: activeFormIndex === index ? "#dbdbdbff" : "#f0f0f0",
                                            border: "none",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        <div style={{ borderRadius: 8 }}>
                                            {forms[index].photo ? (
                                                <img
                                                    src={
                                                        typeof forms[index].photo === "string"
                                                            ? forms[index].photo
                                                            : URL.createObjectURL(forms[index].photo)
                                                    }
                                                    alt="預覽"
                                                    style={{
                                                        width: 100,
                                                        height: 100,
                                                        objectFit: "contain",
                                                        borderRadius: 8,
                                                        border: "2px solid #000000",
                                                        backgroundColor: "#fff"
                                                    }}
                                                />
                                            ) : (
                                                <Box
                                                    sx={{
                                                        width: 100,
                                                        height: 100,
                                                        background: "#fff",
                                                        border: "1px dashed #ccc",
                                                        borderRadius: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="73" height="69" viewBox="0 0 73 69" fill="none">
                                                        <ellipse cx="11.7839" cy="35.8738" rx="7.37667" ry="10.9231" transform="rotate(-29.3518 11.7839 35.8738)" fill="#D9D9D9" />
                                                        <ellipse cx="25.6509" cy="12.0045" rx="7.37667" ry="10.9231" transform="rotate(-9.72478 25.6509 12.0045)" fill="#D9D9D9" />
                                                        <ellipse cx="7.37667" cy="10.9231" rx="7.37667" ry="10.9231" transform="matrix(-0.871627 -0.49017 -0.49017 0.871627 72.9961 29.9688)" fill="#D9D9D9" />
                                                        <ellipse cx="7.37667" cy="10.9231" rx="7.37667" ry="10.9231" transform="matrix(-0.985631 -0.168916 -0.168916 0.985631 56.4648 2.48438)" fill="#D9D9D9" />
                                                        <path d="M36.1553 35.2969C40.7313 35.2969 44.5896 38.3576 45.8018 42.543L52.3516 53.1035C55.2902 57.8413 53.8323 64.0641 49.0947 67.0029C44.892 69.6098 39.5225 68.7546 36.3115 65.2217C33.1006 68.7543 27.7319 69.6095 23.5293 67.0029C18.7916 64.0642 17.333 57.8413 20.2715 53.1035L26.3027 43.3779C27.2159 38.7705 31.2798 35.2969 36.1553 35.2969Z" fill="#D9D9D9" />
                                                    </svg>
                                                </Box>
                                            )}
                                        </div>

                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize: 16, alignItems: 'center', width: 150 }}>
                                            <div style={{ fontWeight: 700, }}>{t('petName')}</div>
                                            <div>{forms[index].petName}</div>
                                        </div>


                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize: 13, width: isMobile ? 150 : 200, alignItems: 'center', }}>
                                            <div style={{ fontWeight: 700, fontSize: 16 }}>{t('Item')}</div>
                                            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 0 : 10, fontSize: 16 }}>
                                                <div>{forms[index].option}</div>
                                                {forms[index].version && <div>{forms[index].version === "custom" ? t('custom') : t('normal')}</div>}
                                                <div>{forms[index].color === '金色' ? `${t('golden')}` : forms[index].color === '銀色' ? `${t('silver')}` : `${t('white')}`}</div>
                                                <div>{`${forms[index].size}${t('mm')}`}</div>
                                            </div>

                                        </div>

                                        <Divider
                                            orientation="vertical"
                                            flexItem
                                            sx={{ display: "block", minHeight: 100 }}
                                        />
                                        <div style={{ height: 25, alignSelf: isMobile ? 'flex-start' : 'center', display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>

                                            <IconButton color="default" onClick={() => {
                                                if (forms[index].option == 'PTagAir') {
                                                    navigate("/ptag-air/payment?edit=yes");
                                                } else {
                                                    navigate("/ptag/payment?edit=yes");
                                                }
                                            }}>
                                                <Edit size={20} />
                                            </IconButton>
                                            <IconButton color="default" onClick={() => { removeForm(index); decrementFormsAdded(); }}><Trash2 size={20} stroke="red" /></IconButton>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                <Box
                    sx={{
                        width: "100%",
                        pb: { xs: 4, md: 8 },
                    }}
                >

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            alignItems: "flex-start",
                            gap: { xs: 2, md: 5 },
                            width: "100%",
                        }}
                    >
                        <Box sx={{ width: "100%" }}>
                            <Typography fontWeight={700} fontSize={26} mb={2}>
                                {t('deliveryInfo')}
                            </Typography>
                            <Typography fontSize={18} mb={2}>
                                {t('recipient')}
                            </Typography>
                            <TextField
                                placeholder={t('recipient')}
                                fullWidth
                                value={form.lastName}
                                onChange={handleChange("lastName")}
                                error={!!fieldErrors.lastName}
                                helperText={fieldErrors.lastName}
                                sx={{
                                    mb: 2,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                            <Typography fontSize={18} mb={2}>
                                {t('contactNumber')}
                            </Typography>
                            <TextField
                                placeholder="9123 4567"
                                fullWidth
                                value={form.phoneNumber}
                                onChange={handleChange("phoneNumber")}
                                error={!!fieldErrors.phoneNumber}
                                helperText={fieldErrors.phoneNumber}
                                inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                }}
                                sx={{
                                    mb: 2,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                            <Typography fontSize={18} mb={2}>
                                {t('email')}
                            </Typography>
                            <TextField
                                placeholder="example@mail.com"
                                fullWidth
                                value={form.email}
                                onChange={handleChange("email")}
                                error={!!fieldErrors.email}
                                helperText={fieldErrors.email}
                                type="email"
                                sx={{
                                    mb: 2,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                            <FormControl fullWidth sx={{ mb: 2 }}>
                                <Typography fontSize={18} mb={2}>
                                    {t('deliveryMethod')}
                                </Typography>
                                <Select
                                    value={form.delivery}
                                    onChange={handleChange("delivery")}
                                    displayEmpty
                                    sx={{
                                        background: "#fff",
                                        "& .MuiSelect-select": {
                                            color: form.delivery === "" ? "#969696" : "#000", // Gray for placeholder, black for others
                                        },
                                    }}
                                    MenuProps={{
                                        disableScrollLock: true
                                    }}
                                    renderValue={(value) => {
                                        if (value === "" || value === null || value === undefined) return <span style={{ color: "#969696" }}>{t('deliveryMethodPlaceholder')}</span>;
                                        if (value === "SF-HOME-DELIVERY") return t('Delivery');
                                        if (value === "SF-PICKUP") return t('Pickup');
                                        return value;
                                    }}
                                >
                                    <MenuItem value="SF-HOME-DELIVERY">{t('Delivery')}</MenuItem>
                                    <MenuItem value="SF-PICKUP">{t('Pickup')}</MenuItem>
                                </Select>
                            </FormControl>
                            <div style={{}}>
                                {form.delivery === "SF-PICKUP" ? (
                                    form.netCode && (
                                        <div>
                                            <span>{t('address')}</span>
                                            <Box sx={{
                                                padding: 1,
                                                border: "1px solid #ccc",
                                                borderRadius: 2,
                                                backgroundColor: "white",
                                                my: 2,
                                            }}>
                                                <div style={{ fontWeight: 700, fontSize: 20 }}>{form.serviceName}</div>
                                                <div style={{ fontWeight: 400, fontSize: 12 }}>{form.shippingAddress}</div>
                                            </Box>
                                        </div>
                                    )

                                ) : form.delivery === "SF-HOME-DELIVERY" ? (
                                    <div>
                                        <span>{t('address')}</span>
                                        <TextField
                                            placeholder={t('address')}
                                            fullWidth
                                            value={form.address}
                                            onChange={handleChange("address")}
                                            sx={{
                                                my: 2,
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                        />
                                    </div>
                                ) : (<></>)}

                            </div>
                            {form.delivery === "SF-PICKUP" && (
                                <div style={{ margin: "10px 0", width: "fit-content", display: "flex", gap: "10px", alignItems: "center", cursor: "pointer" }}>
                                    <div onClick={() => setShowPickupMaps(true)} style={{ width: "fit-content", display: "flex", gap: "10px", alignItems: "center", cursor: "pointer" }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#65A8FB" xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true" role="img"><path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M6 8c0 2.5 2 5.5 6 9 4-3.5 6-6.5 6-9A6 6 0 0 0 6 8Zm8.25 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                                                fill="#FFB60C"></path><path
                                                    d="m6.618 16-2 4h14.764l-2-4H17a1 1 0 1 1 0-2h1a1 1 0 0 1 .904.572l2.267 4.534A2 2 0 0 1 19.38 22H4.619a2 2 0 0 1-1.789-2.894l2.267-4.534A1 1 0 0 1 6 14h1a1 1 0 1 1 0 2h-.382Z"
                                                    fill="#FFB60C"></path></svg>
                                        <div
                                            style={{ color: "#FFB60C", fontSize: 15, textDecoration: "none" }}
                                        >
                                            {t('pickupLocation')}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <Box mb={4}>
                                <Typography fontWeight={700} fontSize={18} mb={3}>
                                    {t('paymentMethod')}
                                </Typography>

                                <FormControl component="fieldset" sx={{ mb: 2 }}>
                                    <RadioGroup
                                        row
                                        value={form.paymentWay}
                                        onChange={handleChange("paymentWay")}
                                    >
                                        <FormControlLabel
                                            value="FPS"
                                            control={<Radio
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: '#FFB60C', // Checked color
                                                    },
                                                }} />}
                                            label={t('fps')}
                                        />
                                        <FormControlLabel
                                            value="BANK"
                                            control={<Radio
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: '#FFB60C', // Checked color
                                                    },
                                                }} />}
                                            label={t('bankTransfer')}
                                        />
                                    </RadioGroup>
                                </FormControl>


                                {/* <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
                                        gap: 2,
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        onClick={() => handleChange("paymentWay")({ target: { name: "paymentWay", value: "CARD" } })}
                                        sx={{
                                            padding: 2,
                                            border: '2px solid',
                                            borderColor: form.paymentWay === "CARD" ? '#FFB60C' : '#e0e0e0',
                                            borderRadius: '12px',
                                            backgroundColor: form.paymentWay === "CARD" ? '#fffbf0' : '#f5f5f5',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            '&:hover': {
                                                borderColor: '#FFB60C',
                                                backgroundColor: '#fffbf0',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="60" width="60" viewBox="-74.7 -40.204 647.4 241.224"><defs><linearGradient x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="scale(89.72793 -89.72793) rotate(-20.218 .966 -.457)" spreadMethod="pad" id="b"><stop offset="0" stop-color="#222357" /><stop offset="1" stop-color="#254aa5" /></linearGradient><clipPath clipPathUnits="userSpaceOnUse" id="a"><path d="M413.742 90.435c-.057-4.494 4.005-7.002 7.065-8.493 3.144-1.53 4.2-2.511 4.188-3.879-.024-2.094-2.508-3.018-4.833-3.054-4.056-.063-6.414 1.095-8.289 1.971l-1.461-6.837c1.881-.867 5.364-1.623 8.976-1.656 8.478 0 14.025 4.185 14.055 10.674.033 8.235-11.391 8.691-11.313 12.372.027 1.116 1.092 2.307 3.426 2.61 1.155.153 4.344.27 7.959-1.395l1.419 6.615c-1.944.708-4.443 1.386-7.554 1.386-7.98 0-13.593-4.242-13.638-10.314m34.827 9.744c-1.548 0-2.853-.903-3.435-2.289l-12.111-28.917h8.472l1.686 4.659h10.353l.978-4.659h7.467l-6.516 31.206h-6.894m1.185-8.43l2.445-11.718h-6.696l4.251 11.718m-46.284 8.43l-6.678-31.206h8.073l6.675 31.206h-8.07m-11.943 0l-8.403-21.24-3.399 18.06c-.399 2.016-1.974 3.18-3.723 3.18h-13.737l-.192-.906c2.82-.612 6.024-1.599 7.965-2.655 1.188-.645 1.527-1.209 1.917-2.742l6.438-24.903h8.532l13.08 31.206h-8.478" /></clipPath></defs><g clip-path="url(#a)" transform="matrix(4.98469 0 0 -4.98469 -1804.82 502.202)"><path d="M0 0l98.437 36.252 22.394-60.809-98.436-36.252" fill="url(#b)" transform="translate(351.611 96.896)" /></g></svg>

                                            <svg width="60" height="60" viewBox="0 -54.25 482.51 482.51" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
                                                <title>mastercard</title>
                                                <g>
                                                    <path d="M220.13,421.67V396.82c0-9.53-5.8-15.74-15.32-15.74-5,0-10.35,1.66-14.08,7-2.9-4.56-7-7-13.25-7a14.07,14.07,0,0,0-12,5.8v-5h-7.87v39.76h7.87V398.89c0-7,4.14-10.35,9.94-10.35s9.11,3.73,9.11,10.35v22.78h7.87V398.89c0-7,4.14-10.35,9.94-10.35s9.11,3.73,9.11,10.35v22.78Zm129.22-39.35h-14.5v-12H327v12h-8.28v7H327V408c0,9.11,3.31,14.5,13.25,14.5A23.17,23.17,0,0,0,351,419.6l-2.49-7a13.63,13.63,0,0,1-7.46,2.07c-4.14,0-6.21-2.49-6.21-6.63V389h14.5v-6.63Zm73.72-1.24a12.39,12.39,0,0,0-10.77,5.8v-5h-7.87v39.76h7.87V399.31c0-6.63,3.31-10.77,8.7-10.77a24.24,24.24,0,0,1,5.38.83l2.49-7.46a28,28,0,0,0-5.8-.83Zm-111.41,4.14c-4.14-2.9-9.94-4.14-16.15-4.14-9.94,0-16.15,4.56-16.15,12.43,0,6.63,4.56,10.35,13.25,11.6l4.14.41c4.56.83,7.46,2.49,7.46,4.56,0,2.9-3.31,5-9.53,5a21.84,21.84,0,0,1-13.25-4.14l-4.14,6.21c5.8,4.14,12.84,5,17,5,11.6,0,17.81-5.38,17.81-12.84,0-7-5-10.35-13.67-11.6l-4.14-.41c-3.73-.41-7-1.66-7-4.14,0-2.9,3.31-5,7.87-5,5,0,9.94,2.07,12.43,3.31Zm120.11,16.57c0,12,7.87,20.71,20.71,20.71,5.8,0,9.94-1.24,14.08-4.56l-4.14-6.21a16.74,16.74,0,0,1-10.35,3.73c-7,0-12.43-5.38-12.43-13.25S445,389,452.07,389a16.74,16.74,0,0,1,10.35,3.73l4.14-6.21c-4.14-3.31-8.28-4.56-14.08-4.56-12.43-.83-20.71,7.87-20.71,19.88h0Zm-55.5-20.71c-11.6,0-19.47,8.28-19.47,20.71s8.28,20.71,20.29,20.71a25.33,25.33,0,0,0,16.15-5.38l-4.14-5.8a19.79,19.79,0,0,1-11.6,4.14c-5.38,0-11.18-3.31-12-10.35h29.41v-3.31c0-12.43-7.46-20.71-18.64-20.71h0Zm-.41,7.46c5.8,0,9.94,3.73,10.35,9.94H364.68c1.24-5.8,5-9.94,11.18-9.94ZM268.59,401.79V381.91h-7.87v5c-2.9-3.73-7-5.8-12.84-5.8-11.18,0-19.47,8.7-19.47,20.71s8.28,20.71,19.47,20.71c5.8,0,9.94-2.07,12.84-5.8v5h7.87V401.79Zm-31.89,0c0-7.46,4.56-13.25,12.43-13.25,7.46,0,12,5.8,12,13.25,0,7.87-5,13.25-12,13.25-7.87.41-12.43-5.8-12.43-13.25Zm306.08-20.71a12.39,12.39,0,0,0-10.77,5.8v-5h-7.87v39.76H532V399.31c0-6.63,3.31-10.77,8.7-10.77a24.24,24.24,0,0,1,5.38.83l2.49-7.46a28,28,0,0,0-5.8-.83Zm-30.65,20.71V381.91h-7.87v5c-2.9-3.73-7-5.8-12.84-5.8-11.18,0-19.47,8.7-19.47,20.71s8.28,20.71,19.47,20.71c5.8,0,9.94-2.07,12.84-5.8v5h7.87V401.79Zm-31.89,0c0-7.46,4.56-13.25,12.43-13.25,7.46,0,12,5.8,12,13.25,0,7.87-5,13.25-12,13.25-7.87.41-12.43-5.8-12.43-13.25Zm111.83,0V366.17h-7.87v20.71c-2.9-3.73-7-5.8-12.84-5.8-11.18,0-19.47,8.7-19.47,20.71s8.28,20.71,19.47,20.71c5.8,0,9.94-2.07,12.84-5.8v5h7.87V401.79Zm-31.89,0c0-7.46,4.56-13.25,12.43-13.25,7.46,0,12,5.8,12,13.25,0,7.87-5,13.25-12,13.25C564.73,415.46,560.17,409.25,560.17,401.79Z" transform="translate(-132.74 -48.5)" />
                                                    <g>
                                                        <rect x="169.81" y="31.89" width="143.72" height="234.42" fill="#ff5f00" />
                                                        <path d="M317.05,197.6A149.5,149.5,0,0,1,373.79,80.39a149.1,149.1,0,1,0,0,234.42A149.5,149.5,0,0,1,317.05,197.6Z" transform="translate(-132.74 -48.5)" fill="#eb001b" />
                                                        <path d="M615.26,197.6a148.95,148.95,0,0,1-241,117.21,149.43,149.43,0,0,0,0-234.42,148.95,148.95,0,0,1,241,117.21Z" transform="translate(-132.74 -48.5)" fill="#f79e1b" />
                                                    </g>
                                                </g>
                                            </svg>
                                        </Box>
                                    </Box>

                                    <Box
                                        onClick={() => handleChange("paymentWay")({ target: { name: "paymentWay", value: "DIGITAL_WALLET" } })}
                                        sx={{
                                            padding: 2.5,
                                            border: '2px solid',
                                            borderColor: form.paymentWay === "DIGITAL_WALLET" ? '#FFB60C' : '#e0e0e0',
                                            borderRadius: '12px',
                                            backgroundColor: form.paymentWay === "DIGITAL_WALLET" ? '#fffbf0' : '#f5f5f5',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            '&:hover': {
                                                borderColor: '#FFB60C',
                                                backgroundColor: '#fffbf0',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                                            <svg width="50" height="50" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">

                                                <path fill="#2DC100" d="M300 255c0 24.854-20.147 45-45 45H45c-24.854 0-45-20.146-45-45V45C0 20.147 20.147 0 45 0h210c24.853 0 45 20.147 45 45v210z" />

                                                <g fill="#FFF">

                                                    <path d="M200.803 111.88c-24.213 1.265-45.268 8.605-62.362 25.188-17.271 16.754-25.155 37.284-23 62.734-9.464-1.172-18.084-2.462-26.753-3.192-2.994-.252-6.547.106-9.083 1.537-8.418 4.75-16.488 10.113-26.053 16.092 1.755-7.938 2.891-14.889 4.902-21.575 1.479-4.914.794-7.649-3.733-10.849-29.066-20.521-41.318-51.232-32.149-82.85 8.483-29.25 29.315-46.989 57.621-56.236 38.635-12.62 82.054.253 105.547 30.927 8.485 11.08 13.688 23.516 15.063 38.224zm-111.437-9.852c.223-5.783-4.788-10.993-10.74-11.167-6.094-.179-11.106 4.478-11.284 10.483-.18 6.086 4.475 10.963 10.613 11.119 6.085.154 11.186-4.509 11.411-10.435zm58.141-11.171c-5.974.11-11.022 5.198-10.916 11.004.109 6.018 5.061 10.726 11.204 10.652 6.159-.074 10.83-4.832 10.772-10.977-.051-6.032-4.981-10.79-11.06-10.679z" />

                                                    <path d="M255.201 262.83c-7.667-3.414-14.7-8.536-22.188-9.318-7.459-.779-15.3 3.524-23.104 4.322-23.771 2.432-45.067-4.193-62.627-20.432-33.397-30.89-28.625-78.254 10.014-103.568 34.341-22.498 84.704-14.998 108.916 16.219 21.129 27.24 18.646 63.4-7.148 86.284-7.464 6.623-10.15 12.073-5.361 20.804.884 1.612.985 3.653 1.498 5.689zm-87.274-84.499c4.881.005 8.9-3.815 9.085-8.636.195-5.104-3.91-9.385-9.021-9.406-5.06-.023-9.299 4.318-9.123 9.346.166 4.804 4.213 8.69 9.059 8.696zm56.261-18.022c-4.736-.033-8.76 3.844-8.953 8.629-.205 5.117 3.772 9.319 8.836 9.332 4.898.016 8.768-3.688 8.946-8.562.19-5.129-3.789-9.364-8.829-9.399z" />

                                                </g>

                                            </svg>

                                            <svg viewBox="0 0 854.9970000000001 299.99699999999996" xmlns="http://www.w3.org/2000/svg" width="80" height="40"><path d="M48.508 0C21.694 0 0 21.511 0 48.068v203.87c0 26.536 21.694 48.059 48.508 48.059h205.81c26.793 0 48.496-21.522 48.496-48.059v-2.086c-.902-.372-78.698-32.52-118.24-51.357-26.677 32.524-61.086 52.256-96.812 52.256-60.412 0-80.927-52.38-52.322-86.86 6.237-7.517 16.847-14.698 33.314-18.718 25.76-6.27 66.756 3.915 105.18 16.477 6.912-12.614 12.726-26.506 17.057-41.297H72.581v-11.88h61.057V87.168H59.687V75.28h73.951v-30.39s0-5.119 5.236-5.119h29.848v35.508h73.107v11.891h-73.107v21.303h59.674c-5.71 23.176-14.38 44.509-25.264 63.236 18.111 6.49 34.368 12.646 46.484 16.666 40.413 13.397 51.74 15.034 53.201 15.205V48.069c0-26.557-21.704-48.068-48.496-48.068H48.511zm33.207 162.54c-2.593.03-5.198.17-7.822.426-7.565.753-21.768 4.06-29.533 10.865-23.274 20.109-9.344 56.87 37.762 56.87 27.383 0 54.743-17.343 76.236-45.114-27.71-13.395-51.576-23.335-76.643-23.047z" fill="#00a1e9" /><path d="M829.48 208.55l-13.517 29.164-13.718-29.164h-13.402l20.871 40.322v28.127h12.295v-28.127l.074-.157 20.787-40.165zm-98.969 17.644l9.535 28.389h-19.407zm12.464 37.015l4.594 13.786h12.885l-25.37-68.45h-9.851l-25.286 68.45h12.896l4.793-13.786zm-96.164-21.937h-13.686v-23.417h13.686c6.88 0 10.989 5.977 10.989 11.755 0 5.653-3.846 11.661-10.989 11.661m.695-32.723h-26.772v68.45h12.39v-26.316h14.381c13.36 0 22.694-8.667 22.694-21.072s-9.334-21.061-22.694-21.061m-89.406 68.45H570.5v-68.45h-12.4zm-87.163-68.449V277h41.711v-9.327h-29.32V208.55zm-70.587 17.644l9.525 28.389h-19.396zm12.464 37.015l4.594 13.786h12.875l-25.37-68.45h-9.84l-25.287 68.45h12.885l4.794-13.786zm87.23-188.47H446.89V55.813h61.635V44.026H446.89V20.044h-27.477c-3.013 0-5.447 2.512-5.447 5.6v18.382h-61.203v11.787h61.203V74.74H362.31v11.776H465.2s-5.7 22.12-33.925 45.891c-25.286-19.02-33.736-34.167-33.736-34.167h-27.604c11.168 19.23 27.035 34.628 44.124 46.844-15.698 10.133-36.054 19.9-62.372 27.72v14.11s40.605-7.61 79.851-30.587c39.31 22.8 78.787 30.587 78.787 30.587v-13.357c-25.265-9.138-45.283-19.188-61.002-28.88 22.768-16.76 42.723-39.507 50.72-69.937m172.66-52.334h-27.668V51.13h-68.198v11.567h68.198v103.27c-.242 2.366-2.117 4.208-4.467 4.334h-14.065v11.965h35.864c5.679-.23 10.21-4.91 10.336-10.709V62.696h11.231V51.129h-11.23zm-58.349 59.777c-1.011-2.051-3.076-3.465-5.478-3.486h-23.052l17.964 56.192h27.267zm-68.092-61.137L514.527 95.63h24.348v88.747H565.5V66.656h-9.65l20.05-45.609zm308.73 159.26l-9.724-32.639c-.653-2.083-2.55-3.59-4.805-3.59h-25.78l7.48 25.07H791.85v-48.57h59.517v-11.557H791.85V86.157h59.517V74.6h-148.52v11.557h59.506v22.862h-59.506v11.557h59.506v48.57h-59.506v11.558h152.15l-.127-.398zm-121.2-133.28h86.678v17.052h30.965V43.874c-.01-.042-.01-.063-.01-.115 0-4.543-3.582-8.217-8.018-8.29h-50.108V19.568H760.9v15.9h-58.063v28.61h30.954z" fill="#3f3b3a" /></svg>
                                        </Box>
                                    </Box>

                                    <Box
                                        onClick={() => handleChange("paymentWay")({ target: { name: "paymentWay", value: "APPLE_PAY" } })}
                                        sx={{
                                            padding: 2.5,
                                            border: '2px solid',
                                            borderColor: form.paymentWay === "APPLE_PAY" ? '#FFB60C' : '#e0e0e0',
                                            borderRadius: '12px',
                                            backgroundColor: form.paymentWay === "APPLE_PAY" ? '#fffbf0' : '#f5f5f5',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            '&:hover': {
                                                borderColor: '#FFB60C',
                                                backgroundColor: '#fffbf0',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>

                                            <svg xmlns="http://www.w3.org/2000/svg" height="60" width="60" viewBox="-76.79115 -52.55 665.5233 315.3"><path d="M93.541 27.1c-6 7.1-15.6 12.7-25.2 11.9-1.2-9.6 3.5-19.8 9-26.1 6-7.3 16.5-12.5 25-12.9 1 10-2.9 19.8-8.8 27.1m8.7 13.8c-13.9-.8-25.8 7.9-32.4 7.9-6.7 0-16.8-7.5-27.8-7.3-14.3.2-27.6 8.3-34.9 21.2-15 25.8-3.9 64 10.6 85 7.1 10.4 15.6 21.8 26.8 21.4 10.6-.4 14.8-6.9 27.6-6.9 12.9 0 16.6 6.9 27.8 6.7 11.6-.2 18.9-10.4 26-20.8 8.1-11.8 11.4-23.3 11.6-23.9-.2-.2-22.4-8.7-22.6-34.3-.2-21.4 17.5-31.6 18.3-32.2-10-14.8-25.6-16.4-31-16.8m80.3-29v155.9h24.2v-53.3h33.5c30.6 0 52.1-21 52.1-51.4s-21.1-51.2-51.3-51.2zm24.2 20.4h27.9c21 0 33 11.2 33 30.9s-12 31-33.1 31h-27.8zm129.8 136.7c15.2 0 29.3-7.7 35.7-19.9h.5v18.7h22.4V90.2c0-22.5-18-37-45.7-37-25.7 0-44.7 14.7-45.4 34.9h21.8c1.8-9.6 10.7-15.9 22.9-15.9 14.8 0 23.1 6.9 23.1 19.6v8.6l-30.2 1.8c-28.1 1.7-43.3 13.2-43.3 33.2 0 20.2 15.7 33.6 38.2 33.6zm6.5-18.5c-12.9 0-21.1-6.2-21.1-15.7 0-9.8 7.9-15.5 23-16.4l26.9-1.7v8.8c0 14.6-12.4 25-28.8 25zm82 59.7c23.6 0 34.7-9 44.4-36.3l42.5-119.2h-24.6l-28.5 92.1h-.5l-28.5-92.1h-25.3l41 113.5-2.2 6.9c-3.7 11.7-9.7 16.2-20.4 16.2-1.9 0-5.6-.2-7.1-.4v18.7c1.4.4 7.4.6 9.2.6z" /></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="Google-Pay--Streamline-Svg-Logos" height="60" width="60">
                                                <desc>
                                                    Google Pay Streamline Icon: https://streamlinehq.com
                                                </desc>
                                                <path fill="#5f6368" d="M16.9078 9.8571c0.64605 0 1.145275 0.176175 1.527025 0.528575 0.38175 0.3524 0.55795 0.82225 0.55795 1.40955v2.819125h-0.82225v-0.64605h-0.02935c-0.3524 0.5286 -0.851625 0.792875 -1.438925 0.792875 -0.499225 0 -0.939725 -0.146825 -1.2921 -0.440475 -0.323025 -0.293675 -0.5286 -0.704775 -0.5286 -1.145275 0 -0.46985 0.1762 -0.8516 0.5286 -1.145275 0.352375 -0.29365 0.8516 -0.4111 1.438925 -0.4111 0.528575 0 0.9397 0.088075 1.262725 0.29365v-0.20555c0 -0.2741 -0.102325 -0.548175 -0.306975 -0.72675l-0.045425 -0.036775c-0.234925 -0.20555 -0.528575 -0.323025 -0.8516 -0.323025 -0.499225 0 -0.880975 0.205575 -1.145275 0.616675l-0.7635 -0.46985c0.46985 -0.616675 1.086525 -0.910325 1.908775 -0.910325Zm-4.140575 -1.996875c0.52695 0 1.0277 0.18335 1.42805 0.525325l0.0696 0.061975c0.411125 0.3524 0.616675 0.880975 0.616675 1.438925 0 0.55795 -0.20555 1.057175 -0.616675 1.438925 -0.411125 0.381775 -0.91035 0.587325 -1.49765 0.587325l-1.409575 -0.029375v2.731025h-0.880975V7.860225h2.29055ZM17.02525 12.323825c-0.352375 0 -0.646025 0.0881 -0.88095 0.264275 -0.23495 0.14685 -0.3524 0.3524 -0.3524 0.6167 0 0.234925 0.11745 0.440475 0.29365 0.55795 0.205575 0.146825 0.4405 0.234925 0.675425 0.234925 0.3289 0 0.6578 -0.1279 0.91505 -0.35985l0.054025 -0.051275c0.29365 -0.2643 0.440475 -0.587325 0.440475 -0.9397 -0.264275 -0.205575 -0.64605 -0.323025 -1.145275 -0.323025ZM12.82595 8.68245h-1.4683v2.349275h1.4683c0.323025 0 0.64605 -0.117475 0.8516 -0.3524 0.46985 -0.440475 0.46985 -1.174625 0.029375 -1.6151l-0.029375 -0.029375c-0.234925 -0.234925 -0.528575 -0.38175 -0.8516 -0.3524Zm10.924075 1.321475L20.842825 16.66995h-0.880975l1.086525 -2.3199 -1.908775 -4.316775h0.9397l1.3802 3.31835h0.029375l1.350825 -3.31835h0.910325v-0.02935Z" stroke-width="0.25"></path>
                                                <path fill="#4285f4" d="M7.86325 11.296025c0 -0.2643 -0.029375 -0.5286 -0.058725 -0.7929H4.1338v1.497675h2.084975c-0.0881 0.46985 -0.3524 0.910325 -0.763525 1.174625v0.969075h1.262725c0.73415 -0.675425 1.145275 -1.67385 1.145275 -2.848475Z" stroke-width="0.25"></path>
                                                <path fill="#34a853" d="M4.13375 15.0842c1.057175 0 1.93815 -0.352375 2.5842 -0.9397l-1.26275 -0.969075c-0.352375 0.234925 -0.792875 0.38175 -1.32145 0.38175 -0.99845 0 -1.8794175 -0.6754 -2.173075 -1.615125H0.66858v0.99845c0.6754125 1.32145 1.99687 2.1437 3.46517 2.1437Z" stroke-width="0.25"></path>
                                                <path fill="#fbbc04" d="M1.96056 11.94205c-0.176195 -0.46985 -0.176195 -0.998425 0 -1.49765v-0.99845H0.6684625c-0.55795025 1.08655 -0.55795025 2.37865 0 3.49455l1.2920975 -0.99845Z" stroke-width="0.25"></path>
                                                <path fill="#ea4335" d="M4.133675 8.85865c0.55795 0 1.086525 0.20555 1.49765 0.587325l1.1159 -1.1159c-0.704775 -0.64605 -1.644475 -1.027825 -2.584175 -0.99845 -1.4683 0 -2.819125 0.82225 -3.465175 2.1437l1.2920975 0.99845c0.2642925 -0.9397 1.1452775 -1.615125 2.1437025 -1.615125Z" stroke-width="0.25"></path>
                                            </svg>
                                        </Box>
                                    </Box>

                                    <Box
                                        onClick={() => handleChange("paymentWay")({ target: { name: "paymentWay", value: "BANK" } })}
                                        sx={{
                                            padding: 2.5,
                                            border: '2px solid',
                                            borderColor: form.paymentWay === "BANK" ? '#FFB60C' : '#e0e0e0',
                                            borderRadius: '12px',
                                            backgroundColor: form.paymentWay === "BANK" ? '#fffbf0' : '#f5f5f5',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 1,
                                            '&:hover': {
                                                borderColor: '#FFB60C',
                                                backgroundColor: '#fffbf0',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                            },
                                        }}
                                    >
                                        <Typography fontSize={20} fontWeight={600} textAlign="center">
                                            FPS / Bank Transfer
                                        </Typography>
                                    </Box>
                                </Box> */}
                                
                            </Box>


                        </Box>



                        {/* Right Column: Order Summary (Sticky on desktop) */}
                        <Box
                            sx={{
                                width: { xs: "100%", md: "400px" },
                                flexShrink: 0,
                            }}
                        >
                            <Typography variant="h6" fontWeight="bold" mb={3}>
                                {t('orderSummary')}
                            </Typography>

                            {/* List of items */}
                            {forms.map((form, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        py: 1.5,
                                        borderBottom: "1px solid #eee",
                                    }}
                                >
                                    <Box>
                                        <Typography fontWeight={500}>
                                            {form.petName ? `${form.petName}` : form.option}
                                        </Typography>

                                    </Box>
                                    <Typography fontWeight={600}>HKD ${form.price || 0}</Typography>
                                </Box>
                            ))}

                            {/* Subtotal */}
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, pb: 1 }}>
                                <Typography>{t('subtotal')}</Typography>
                                <Typography fontWeight={600}>
                                    HKD ${forms.reduce((sum, f) => sum + (f.price || 0), 0)}
                                </Typography>
                            </Box>

                            {/* Shipping */}
                            <Box sx={{ display: "flex", justifyContent: "space-between", pb: 2 }}>
                                <Typography>{t('shippingFee')}</Typography>
                                <Typography fontWeight={600}>HKD ${50 * (forms.length)}</Typography>
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            {/* Grand Total */}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="h6" fontWeight="bold">
                                    {t('total')}
                                </Typography>
                                <Typography variant="h5" fontWeight="bold" color="#FFB60C">
                                    HKD ${forms.reduce((sum, f) => sum + (f.price || 0), 0) + 50 * (forms.length)}
                                </Typography>
                            </Box>

                            {/* Checkout Button */}
                            <Button
                                fullWidth
                                variant="contained"
                                size="large"
                                disabled={!isFormValid}
                                sx={{
                                    mt: 4,
                                    py: 1.8,
                                    backgroundColor: "#FFB60C",
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                    "&:hover": { backgroundColor: "#e5a300" },
                                }}
                                onClick={() => setShowConfirmationPopup(true)}

                            >
                                {t('Confirm')}
                            </Button>


                            <Button
                                fullWidth
                                variant="outlined"
                                sx={{ mt: 2, py: 1.5 }}
                                onClick={() => { removeAllForms(); removeAllFormsAdded(); }}
                            >
                                {t('cancel')}
                            </Button>
                        </Box>
                    </Box>
                </Box>

            </Container>

            <Footer />
            {showConfirmationPopup && (
                <div style={popupOverlayStyle}>
                    <div className="bg-white rounded-lg shadow-lg p-8 max-w-xs w-full flex flex-col items-center">
                        <div className="text-center font-semibold mb-6">{t('Confirmation')}</div>
                        <div className="flex w-full flex-col gap-4">
                            <button
                                className="flex w-full py-2 rounded bg-yellow-400 hover:bg-yellow-500 text-black font-bold disabled:opacity-50"
                                onClick={handleConfirm}
                                style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "10px",
                                }}
                                disabled={loadingButton}
                            >
                                {t("Submit")}
                                {loadingButton && (
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <CircularProgress size={15} color="inherit" />
                                    </span>
                                )}
                            </button>
                            <button
                                className="flex-1 w-full py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold"
                                onClick={() => setShowConfirmationPopup(false)}
                            >
                                {t("cancel")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showPickupMaps && (
                <div style={popupOverlayStyle}>
                    <div style={popupContentStyle2}>
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center", position: "relative", width: "100%", }}>
                                <div style={{ color: "black", fontSize: isMobile ? 15 : 20, fontWeight: 700, }}>{t("pickupLocation")}</div>
                                <button style={closeButtonStyle} onClick={handleClosePopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                        <path d="M22.5 7.5L7.5 22.5" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.5 7.5L22.5 22.5" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <PickUpMap
                            showPickupMap={showPickupMaps}
                            setShowPickupMap={setShowPickupMaps}
                        />
                    </div>
                </div>
            )}
        </Box>
    );
};

export default ShoppingCart;
